import { j as m } from "../../../jsx-runtime-B6kdoens.js";
import { c as i } from "../../../index-CROKJrb5.js";
import { c, f as n } from "../../../create-component-CBAeEoQ6.js";
import { useFooterStateAtoms as u } from "../FooterState/index.js";
import { Typography as l } from "../../Typography/index.js";
import { u as p } from "../../../react-B_GApDuV.js";
const f = i({
  base: "cur-flex cur-flex-wrap cur-flex-col cur-gap-[0.125rem] [&_a]:cur-no-underline hover:[&_a]:cur-underline",
  variants: {
    mode: {
      dark: "cur-text-inverse",
      light: null
    }
  }
}), F = c(
  "FooterDetail",
  n(
    ({ children: e, className: o, ...r }, t) => {
      const { modeAtom: a } = u(), s = p(a);
      return /* @__PURE__ */ m.jsx(
        l,
        {
          ref: t,
          className: f({ className: o, mode: s }),
          as: "div",
          size: "meta",
          ...r,
          children: e
        }
      );
    }
  )
);
export {
  F as FooterDetail
};
//# sourceMappingURL=index.js.map
